import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { RefreshGridService } from '../../shared/services/refresh-grid.service'; // Import the shared service
import { ClientService } from '../../services/client.service';
import { DashboardEngagementDetailsResponse } from '../../models/client-engagement/dashboardEngagementDetailsResponse.model';
import {
  GridModule,
  CellClickEvent,
  DataBindingDirective,
} from '@progress/kendo-angular-grid';
import { KENDO_TOOLTIPS, TooltipDirective } from '@progress/kendo-angular-tooltip';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { InputsModule, SliderModule } from '@progress/kendo-angular-inputs';
import {
  KENDO_LAYOUT,
  LayoutModule,
  SelectEvent,
} from '@progress/kendo-angular-layout';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';
import {
  KENDO_ICONS,
  IconsModule,
  SVGIcon,
} from '@progress/kendo-angular-icons';
import {
  checkCircleIcon,
  checkOutlineIcon,
  xCircleIcon,
  xOutlineIcon,
} from '@progress/kendo-svg-icons';

import { KENDO_BUTTONS, ButtonsModule } from '@progress/kendo-angular-buttons';
import { LabelModule } from '@progress/kendo-angular-label';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ListViewModule } from '@progress/kendo-angular-listview';
import { GaugesModule } from '@progress/kendo-angular-gauges';
import { IntlModule } from '@progress/kendo-angular-intl';
import {
  envelopIcon,
  plusIcon,
  eyeIcon,
  minusIcon,
  starOutlineIcon, starIcon,
  arrowRotateCwIcon,
} from '@progress/kendo-svg-icons';
import { process } from '@progress/kendo-data-query';
import { CommonModule } from '@angular/common';
import { ElementRef } from '@angular/core';
import { EngagementrequestComponent } from '../shared/request-panel/request-wrapper/engagement-request-wrapper/engagementrequest/engagementrequest.component';
import { Roles } from '../../constants/roles';
import { AuthUserService } from '../../shared/auth/auth-user.service';
import { RemoveEngagementComponent } from './remove-engagement/remove-engagement.component';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { EngagementaccessrequestComponent } from '../shared/request-panel/request-wrapper/engagement-request-wrapper/engagementaccessrequest/engagementaccessrequest.component';
import { UserAddRequestComponent } from '../shared/request-panel/request-wrapper/user-request-wrapper/useraddrequest/useraddrequest.component';
import { MemberService } from '../../services/member.service';
import { snowFlake } from '../../custom-icons/snowFlake';
import { DEFAULT_GRID_PAGER_SETTINGS } from '../../constants/gridPagerSettings';
import { GridPagerSettings } from '../../models/common/gridPagerSettings.model';
import { ModuleTypeDescriptionEnum } from '../../enums/moduleTypeDescriptionEnum';
import { ModuleTypeEnum } from '../../enums/moduleTypeEnum';
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-engagement',
  standalone: true,
  templateUrl: './engagement.component.html',
  styleUrls: ['./engagement.component.scss'],
  // encapsulation:ViewEncapsulation.None,
  imports: [
    KENDO_LAYOUT,
    KENDO_ICONS,
    KENDO_BUTTONS,
    KENDO_TOOLTIPS,
    GridModule,
    ChartsModule,
    InputsModule,
    SliderModule,
    LayoutModule,
    ScrollViewModule,
    IconsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    ListViewModule,
    GaugesModule,
    IntlModule,
    EngagementrequestComponent,
    RemoveEngagementComponent,
    CommonModule,
    IndicatorsModule,
    EngagementaccessrequestComponent,
    UserAddRequestComponent,
    NgxSpinnerModule
  ],
})
export class EngagementComponent implements OnInit, OnDestroy {
  @ViewChild('anchor', { static: true }) anchor!: ElementRef;
  public engagementList: any[] = [];
  public contacts: any[] = [
    { id: 1, name: 'Jenson Delaney', email: 'jenson.delany@mail.com' },
    { id: 2, name: 'Amaya Coffey', email: 'amaya.coffey@mail.com' },
    { id: 3, name: 'Habib Joyce', email: 'habib.joyce@mail.com' },
    { id: 4, name: 'Lilly-Ann Roche', email: 'lilly-ann.roche@mail.com' },
    { id: 5, name: 'Giulia Haworth', email: 'giulia.haworth@mail.com' },
    { id: 6, name: 'Dawson Humphrey', email: 'dawson.humphrey@mail.com' },
    { id: 7, name: 'Reilly McCullough', email: 'reilly.mccullough@mail.com' },
  ];
  public value = 76;
  public gridView: any[] = [];
  public dashboardGridColumns: any[] = ['clientId', 'clientName'];
  public plusIcon: SVGIcon = plusIcon;
  public eyeIcon: SVGIcon = eyeIcon;
  public starIcon: SVGIcon = starIcon;
  public checkCircleIcon: SVGIcon = checkCircleIcon;
  public starOutlineIcon: SVGIcon = starOutlineIcon;
  public cancelCircleIcon: SVGIcon = xOutlineIcon;
  public snowFlakeIcon: SVGIcon = snowFlake;
  public minusIcon: SVGIcon = minusIcon;
  public envelopIcon: SVGIcon = envelopIcon;
  public xCircle: SVGIcon = xCircleIcon;
  public isEngagementPopupOpen = false;
  public isRequestEngagementPopupOpen = false;
  public readonly userRole = Roles;
  public loggedInUserRole: string | null = '';
  public openRemoveEngPopup: boolean = false;
  public selectedRemoveEng: any;
  public refresh: SVGIcon = arrowRotateCwIcon;
  displayEnagagementLoader: boolean = false;
  private destroy$ = new Subject<void>();

  @ViewChild(DataBindingDirective) dataBinding!: DataBindingDirective;
  @ViewChild(TooltipDirective) public tooltipDir!: TooltipDirective;
  @ViewChild(EngagementrequestComponent)
  engagementRequestComponent!: EngagementrequestComponent;
  @ViewChild('myElement', { static: false }) myElement!: ElementRef;

  public mySelection: string[] = [];
  public expandedDetailKeys: number[] = [];
  public clientId: any = [];
  public clientName: string = '';
  public margin = { horizontal: -30, vertical: -75 };
  public colors = [
    { to: 25, color: '#0058e9' },
    { from: 25, to: 50, color: '#00338D' },
    { from: 50, to: 75, color: '#ffc000' },
    { from: 75, color: '#f31700' },
  ];

  private readonly subscription: Subscription;
  public isEngagementAccessRequestOpen: boolean = false;
  public userProfile: any;
  public openUserRequestPopup: boolean = false;
  public pagerSettings: GridPagerSettings = DEFAULT_GRID_PAGER_SETTINGS;
  showDashboardStaticData!: any;
  public isSwitchDisabled: boolean = false;

  private readonly router = inject(Router);
  private readonly clientService = inject(ClientService);
  private readonly authUserService = inject(AuthUserService);
  private readonly route = inject(ActivatedRoute);
  private readonly sharedService = inject(RefreshGridService);
  private readonly memberService = inject(MemberService);
  private cdr = inject(ChangeDetectorRef);
  private spinner = inject(NgxSpinnerService);

  constructor() {
    this.subscription = this.sharedService.engagementAdded$.subscribe(() => {
      this.refreshEngagementGrid(); // Refresh the grid when an engagement is added
    });
  }

  ngOnInit(): void {
    this.displayEnagagementLoader = true;

    if (!localStorage.getItem('loggedInUserRole')) {
      this.authUserService.loggedInUserProfile.subscribe((userRole) => {
        this.loggedInUserRole = userRole;
      });
    } else
      this.loggedInUserRole = localStorage.getItem('loggedInUserRole') ?? '';

    this.route.paramMap.subscribe((params) => {
      this.clientId = params.get('clientId')!;
      sessionStorage.setItem('clientId', this.clientId);
      this.clientName = sessionStorage.getItem('clientName')!;
    });

    this.loadEngagements();
    this.userProfile = JSON.parse(localStorage.getItem('userProfile') ?? '');
    this.getShowStaticData();
  }

  getShowStaticData() {
    this.sharedService.showStaticData().subscribe({
      next: (data) => {
        this.showDashboardStaticData = data;
      },
      error: (error) => {
        console.error('Error fetching static data:', error);
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe(); // Unsubscribe to prevent memory leaks
    this.destroy$.next();
    this.destroy$.complete();
  }

  onButtonClick(): void {
    // This will open the popup by calling the open method in AddEngagementComponent
  }

  onEngagementPopupClose(): void {
    this.isEngagementPopupOpen = false;
    this.refreshEngagementGrid();
  }

  onRequestEngagementClick(): void {
    if (
      this.loggedInUserRole === this.userRole.GeneralUserRole ||
      this.loggedInUserRole === this.userRole.SupportUserRole ||
      this.loggedInUserRole === this.userRole.EngagementApproverUserRole
    ) {
      this.isRequestEngagementPopupOpen = true;
      this.engagementRequestComponent.open(); // This will open the popup by calling the open method in AddEngagementComponent
    }
  }

  onRequestEngagementPopupClose(): void {
    this.isRequestEngagementPopupOpen = false;
  }

  loadEngagements(): void {
    this.displayEnagagementLoader = true;
    this.spinner.show();
    this.clientService
      .getClientEngagementsWithDetails(this.clientId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (x) => {
          this.engagementList = x.data;
          this.displayEnagagementLoader = false;
          this.spinner.hide();
          this.isSwitchDisabled = false;
        },
        error: (error) => {
          this.displayEnagagementLoader = false;
          this.spinner.hide();
        },
      });
  }

  refreshEngagementGrid(): void {
    this.loadEngagements(); // Refresh engagements
  }

  // Each module object has a unique identifier property like 'id'
  getDistinctModules(modules: any[]): any[] {
    const uniquePropertyKey = 'id'; // Replace 'moduleId' with the property that defines uniqueness
    const distinctModulesMap = new Map(modules.map(module => [module[uniquePropertyKey], module]));
    return Array.from(distinctModulesMap.values());
  }

  getGroup(client: any[]): any[] {
    return [{ engagementId: 1, name: 'string' }];
  }

  onDeleteIconClick(dataItem: any): void {
    // this.deleteDialog.open();
    this.openRemoveEngPopup = true;
    this.selectedRemoveEng = dataItem;
  }

  public closeRemoveEngPopup(): void {
    this.openRemoveEngPopup = false;
    this.selectedRemoveEng = null;
    this.refreshEngagementGrid();
  }

  public expandDetailsBy = (
    dataItem: DashboardEngagementDetailsResponse
  ): number => {
    return dataItem.engagementId;
  };

  public showOnlyBeveragesDetails(dataItem: any): boolean {
    return dataItem.Category.CategoryId === 1;
  }

  public onCellEngagementClick(event: CellClickEvent): void {
    if (event.originalEvent.button === 0) {
      if (event.column.field == 'name') {
        sessionStorage.setItem('engagementName', event.dataItem.name);
        sessionStorage.setItem(
          'engagementStatusId',
          event.dataItem.engagementStatusId
        );
        if (this.loggedInUserRole !== this.userRole.SupportUserRole) {
          this.getLoginUserDetail(event.dataItem);
        } else {
          this.router
            .navigate([
              '/Client',
              this.clientId,
              'EngagementId',
              event.dataItem.engagementId,
            ])
            .then(() => {
              this.cdr.detectChanges();
            });
        }
      }
    }
  }

  public getLoginUserDetail(engagementData: any): any {
    sessionStorage.setItem(
      'engagementId',
      engagementData.engagementId.toString()
    );
    if (engagementData.isEngagementAccessibleToCurrentUser) {
      this.router
        .navigate([
          '/Client',
          this.clientId,
          'EngagementId',
          engagementData.engagementId,
        ])
        .then(() => {
          this.cdr.detectChanges();
        });
    } else {
      this.isEngagementAccessRequestOpen = true;
    }
  }

  public closeEngagementAccessRequestPopup(event: any): void {
    this.isEngagementAccessRequestOpen = false;
    if (event) {
      this.openUserRequestPopup = true;
    }
  }

  public onCellModuleClick(event: CellClickEvent, item: any): void {
    if (event.originalEvent.button === 0) {
      if (event.column.field == 'name') {
        let moduleTypeDescription = ModuleTypeDescriptionEnum.Regulatory;
        if (event.dataItem.moduleTypeId === ModuleTypeEnum.Python) {
          moduleTypeDescription = ModuleTypeDescriptionEnum.Python;
        }
        sessionStorage.setItem('moduleName', event.dataItem.name);
        sessionStorage.setItem('engagementId', item.engagementId);
        sessionStorage.setItem('engagementName', item.name);
        sessionStorage.setItem('moduleId', event.dataItem.id);
        this.router.navigate([
          '/Client',
          this.clientId,
          'EngagementId',
          item.engagementId,
          'moduleId',
          event.dataItem.id,
        ], {
          queryParams: { moduleType: moduleTypeDescription }
        });
      }
    }
  }

  public openEmail(email: string): void {
    window.location.href = `mailto:${email || ''}`;
  }

  public checkIfIdExist(id: number): number {
    return this.expandedDetailKeys.findIndex((i) => i === id);
  }

  public showTooltip(e: MouseEvent): void {
    const element = e.target as HTMLElement;
    if (element.nodeName === 'TD' || element.className === 'k-column-title') {
      this.tooltipDir.toggle(element);
    } else {
      this.tooltipDir.hide();
    }
  }

  public onFilter(value: Event): void {
    const inputValue = (value.target as HTMLInputElement).value;

    this.gridView = process(this.engagementList, {
      filter: {
        logic: 'or',
        filters: [
          { field: 'clientId', operator: 'contains', value: inputValue },
          { field: 'clientName', operator: 'contains', value: inputValue },
          { field: 'clientStatus', operator: 'contains', value: inputValue },
        ],
      },
    }).data;

    this.dataBinding.skip = 0;
  }

  public flagURL(dataItem: { clientName: string }): string {
    // const clientName: string = dataItem.clientName;
    // const image: { [Key: string]: string } = images;
    // return image[clientName];
    return '';
  }

  public onTabSelect(e: SelectEvent): void {}

  public preventExpand(event: any) {
    if (this.loggedInUserRole !== this.userRole.SupportUserRole) {
      this.expandedDetailKeys = [];
      if (event.dataItem.isEngagementAccessibleToCurrentUser) {
        this.expandedDetailKeys = [event.dataItem.engagementId];
      }
    }
  }

  public selectViewEngagementAccessibleToCurrentUser(event: boolean): void {
    this.isSwitchDisabled = true;
    if (event) {
      const engagementList = this.engagementList.filter((e: any) => e.isEngagementAccessibleToCurrentUser === true);
      this.engagementList = engagementList;
      this.isSwitchDisabled = false;
    }
    else{
      this.loadEngagements();
    }
  }

}
